import { CXPAddress } from "src/runtimeComponent/subComponent/AddressComponent";
import { Address } from "../runtimeComponent/subComponent/AddressSearchComponent";
import DataUtils from "./DataUtils";
import { LotTypeMap, PropertIdentifier, PropertIdentifierMap } from "../entities/Enums";

export const getCxpAddressString = (address?: CXPAddress ): string => {
    if (!address || !address.addressLine1) {
        return '';
    }
    let addString = `${address.addressLine2 ? address.addressLine2 + ', ' : ''}${address.addressLine1}`;
    addString += `${address.city ? ', ' + address.city : ''}, ${address.province ?  ', ' + address.province: ', ON'}${address.postalCode? ', ' + address.postalCode : ''}`;
    return addString;
}

export const getUnite = (address: Address, mask = false): string => {
    let unite = '';
    if (address.suiteNumber && address.unitType) {
        unite = address.unitType;
        unite += mask ? DataUtils.maskString(address.suiteNumber, 0) : " " + address.suiteNumber + ' - ';
    }
    return unite;
}

export const getLot = (address: Address, mask = false, lang='en'): string => {
    let lot = '';
    if (address.lotType && address.lotType) {
        lot = LotTypeMap[lang.toUpperCase()][address.lotType];
        lot += mask? DataUtils.maskString(address.lotNumber, 0) : " " + address.lotNumber + ' - ';
    }
    return lot;
}

export const getAddressLine = (address: Address, mask = false): string => {
    if (address.isNoStreetNoAddress) {
        return '';
    }
    const suffix = address.streetNumberSuffix?.trim() ? mask ? DataUtils.maskString(address.streetNumberSuffix.trim(), 0) : '' : '';
    let name =
        (address.streetName + ' ') +
        (address.streetType ?? '') +
        (' ' + (address.streetDirection ?? ''));

    name = mask ? DataUtils.maskString(name.length > 10 ? name.substring(0, 10) : name, 0) : name;
    return ((address.streetNumber ? address.streetNumber + ' ' : '') + suffix + ' ' + name + ', ')
        .replace(/\s+/g, ' ')
        .replace(/\s+,/g, ',');
}

export const getCityAndPost = (address: Address, mask = false): string => {
    const city = mask? DataUtils.maskString(address.municipality, 0) : address.municipality;
    const postCode = mask? DataUtils.maskString(address.postalCode, 0, 3) : address.postalCode;
    return city + ', ' + address.province + ', ' + postCode;
}

export const getRouteType = (address: Address, mask = false): string => {
    let rt = ''
    if (address.routeType && address.routeType) {
        rt = address.routeType + ' ' + address.routeNumber + ', ';
    }
    return rt;
}

export const getPoBox = (address: Address, mask = false): string => {
    if (!address.poBoxNumber) return '';
    return address.poBoxNumber + ', ';
}

export const getDeliveryInstallation = (address: Address, mask = false): string => {
    let di = '';
    if (address.deliveryInstallationType && address.deliveryInstallationName && address.deliveryInstallationArea) {
        di = address.deliveryInstallationType + ' ' + address.deliveryInstallationName + ' ' + address.deliveryInstallationArea + ', ';
    }
    return di;
}

export const getRouteAndDeliveryInstallation = (address: Address, mask = false): string => {
    return getRouteType(address, mask) + getDeliveryInstallation(address, mask);
}

export const getIdentifier = (address: Address, mask = false, lang='en'): string => {
    let pi = '';
    if (address.identifier && address.identifierNumber) {
        pi = PropertIdentifierMap[lang.toUpperCase()][address.identifier];
        pi += mask ? DataUtils.maskString(address.identifierNumber, 0) : ' ' + address.identifierNumber + ', ';
    }
    return pi;
}

export const getTownship = (address: Address, mask = false): string => {
    return address.township ? mask ? DataUtils.maskString(address.township, 0) : address.township + ', ' : '';
}

export const getAddress = (address?: Address | CXPAddress, mask=false, lang='en'): string =>{
    if (!address || Object.keys(address).length === 0) return '';
    if (address.isDetailAddress) {
        const add = address as Address;
        if (add.isNoStreetNoAddress) {
            return getLot(add, mask, lang) + getUnite(add, mask) + getIdentifier(add, mask, lang) + getPoBox(add, mask)
                + getDeliveryInstallation(add, mask) + getTownship(add, mask) + getCityAndPost(add, mask);
        } else {
            return getUnite(add, mask) + getAddressLine(add, mask)
                + getRouteAndDeliveryInstallation(add, mask) + getCityAndPost(add, mask);
        }
    }
    return getCxpAddressString(address as CXPAddress);
}

export const splitAddress=(wholeAddress?: Address, mask=false, lang='en') => {
    if (!wholeAddress) return '';
    const address = getAddress(wholeAddress, mask, lang);
    // console.log(`masked address: ${address}`);
    return address;
}